import { render, staticRenderFns } from "./InvoiceClaimsDashboard.yaml?vue&type=template&id=7b57026e&component"
import script from "./InvoiceClaimsDashboard.yaml?vue&type=script&lang=ts&component"
export * from "./InvoiceClaimsDashboard.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports